import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@app/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService, PasswordLoginOtpChallenge, User } from "@app/core/services/AuthenticationService"
import { AutoLogoutService } from "@app/core/services/AutoLogoutService"
import { UserService } from '@app/core/services/UserService';
import { LocalStorageService } from '@app/core/local-storage/local-storage.service'
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { environment } from '@env/environment';
import { environment as env } from '@env/environment';


@Component({
  standalone: false,
  selector: 'anms-login-emailpass',
  templateUrl: './login-emailpass.component.html',
  styleUrls: ['./login-emailpass.component.css']
})
export class LoginEmailpassComponent implements OnInit, OnDestroy {

    public user = {} as User;
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  appId = 0;
  environment: any = environment;
  versions = environment.versions;
  public appUrl = environment.hostBase;
  logo = env.logoUrl || 'assets/logo.png';
    public errorMsg = '';
    loading = false;
    returnUrl: string;
    isAdmin: boolean = false;
    message: string = 'Kunde inte starta inloggningen.';
    actionButtonLabel: string = 'Retry';
    action: boolean = false;
    setAutoHide: boolean = true;
    autoHide: number = 10000;
  //autoStartToken: string = null;
  bankIdPersonnummer: string = null;
  pid: string = null;
  emailEncrypted: string = null;
    redirectToInvoiceId = null;
    loginType: string = null;
  logOut: boolean = false;
  isBankIdLogin: boolean = false;
  public hideEmailForm: boolean = false;
  bankIdUrl = "";
  selectedLogin: 'bankid' | 'email' = 'bankid';
  private readonly loginMethodKey = 'loginMethod';
  private readonly loginEmailKey = 'loginEmail';
  private readonly loginVisitedKey = 'loginVisited';
  private readonly loginAuthenticatedKey = 'loginAuthenticated';
  visitedBefore = false;
  hasLoggedInBefore = false;
  otpChallenge: PasswordLoginOtpChallenge | null = null;
  otpCode = '';
  otpExpiresInSeconds = 0;
  otpResendInSeconds = 0;
  private otpExpiresAtMs = 0;
  private otpResendAvailableAtMs = 0;
  private otpTimer: ReturnType<typeof setInterval> | null = null;
    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private route: ActivatedRoute,
        public snackBar: MatSnackBar,
      public userService: UserService,
      public autoLogoutService: AutoLogoutService,
      private localStorageService: LocalStorageService,
      private ngZone: NgZone,
      private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {

    this.bankIdUrl = this.environment.bankIdUrl;
    this.hideEmailForm = this.invoiceEditInProgress();
    this.visitedBefore = this.localStorageService.getItem(this.loginVisitedKey) === true;
    this.hasLoggedInBefore = this.localStorageService.getItem(this.loginAuthenticatedKey) === true;
    this.localStorageService.setItem(this.loginVisitedKey, true);
    const storedLogin = this.localStorageService.getItem(this.loginMethodKey);
    const storedEmail = this.localStorageService.getItem(this.loginEmailKey);

    if (storedEmail) {
      this.user.username = storedEmail;
    }

    this.route.queryParams.subscribe(params => {
      
      // Bankid-personnummer från login.sampoolen.se
      this.bankIdPersonnummer = params["bankIdpersonalNumber"] || null;
      this.pid = params["pid"] || null;
      this.isBankIdLogin = this.bankIdPersonnummer ? true : false;
      this.emailEncrypted = params["emailEncrypted"] || null
      this.appId = params["appid"] || env.appId;;
      if (this.isBankIdLogin) {
        this.selectedLogin = 'bankid';
      } else if (storedLogin === 'email' && !this.hideEmailForm) {
        this.selectedLogin = 'email';
      }
      
      //this.loginType = params['logintype'] || null;
      this.logOut = params['logout'] || false;

      // Allready at login page so just delete storage and not the full process
      if (this.logOut)
        this.authenticationService.clearLoginStorage();

      // BankID-inloggning
      if (this.bankIdPersonnummer != null) {
        this.loginWithBankIdToken();
      }
      else {
        this.returnUrl = params['returnUrl'] || '/';

        if (!this.logOut && this.authenticationService.token) {
          this.router.navigateByUrl(this.returnUrl);
        }
      }

    });
    
  }

  ngOnDestroy() {
    this.clearOtpTimer();
  }

    onSubmit()
    {
          this.loginPassword();
    }

    loginPassword() {

      this.loading = true;
      this.authenticationService.login(this.user.username, null, null, null, null, null, this.appId)
            .subscribe(
                data => {
                this.loading = false;

                if (data?.RequiresOtp) {
                  this.localStorageService.setItem(this.loginMethodKey, 'email');
                  this.otpChallenge = data;
                  this.otpCode = '';
                  this.setOtpDeadlines(data);
                  this.startOtpTimer();
                  return;
                }

                if (data?.Jwt) {
                  this.localStorageService.setItem(this.loginAuthenticatedKey, true);
                  this.localStorageService.setItem(this.loginMethodKey, 'email');
                  this.userService.setHttpOptions();
                  this.loginFinished();
                }

                },
                error => {
                    this.loading = false;
                });
  }

  loginBankId(method) {

  }

  loginWithBankIdToken() {
    this.loading = true;
    this.authenticationService.login(this.user.username, null, this.bankIdPersonnummer, this.emailEncrypted, null, this.pid, this.appId)
      .subscribe(
        data => {
          
          this.loading = false;
          if (!data?.Jwt) {
            return;
          }
          // login successful so redirect to return url
          this.userService.setHttpOptions();

          this.localStorageService.setItem(this.loginAuthenticatedKey, true);
          this.loginFinished();

        },
        error => {
          alert('Ett fel inträffade! ' + error);
          this.loading = false;
        });
  }

  loginFinished() {

    // Edit invoice parameter found
    if (this.invoiceEditInProgress()) {
      var invoiceEditId = this.invoiceEditInProgressId();
      this.invoiceEditInProgressClear();
      this.router.navigate(['/invoice-tool/' + invoiceEditId], { queryParams: { showExpressDialog: 'true' } });
    }
    else {
      this.router.navigateByUrl(this.returnUrl);
      }
  }

  verifyOtp() {
    if (!this.otpChallenge || !this.canVerifyOtp()) {
      return;
    }

    this.loading = true;
    this.authenticationService.verifyLoginOtp(this.otpChallenge.ChallengeId, this.otpCode)
      .subscribe(data => {
        this.loading = false;

        if (data?.Jwt) {
          this.localStorageService.setItem(this.loginAuthenticatedKey, true);
          this.localStorageService.setItem(this.loginMethodKey, 'email');
          this.clearOtpState();
          this.userService.setHttpOptions();
          this.loginFinished();
        }
      }, () => {
        this.loading = false;
      });
  }

  resendOtp() {
    if (!this.otpChallenge || this.otpResendInSeconds > 0) {
      return;
    }

    this.loginPassword();
  }

  resetOtpState() {
    this.clearOtpState();
  }

  invoiceEditInProgress() {
    return this.localStorageService.getItem("editInvoice") != null && this.localStorageService.getItem("editInvoice") != 'null' && this.localStorageService.getItem("editInvoice") != 'undefined' ? true : false;
  }

  invoiceEditInProgressId() {
    return this.localStorageService.getItem("editInvoice");
  }

  invoiceEditInProgressClear() {
    return this.localStorageService.removeItem("editInvoice");
  }


  //loginBankId(openOnAnotherUnit: boolean) {

  //  //var currentUserId = this.localStorageService.getItem("bankIdLoginUserId");

  //  if (openOnAnotherUnit) {
  //    // Starta BankId på annan enhet
  //    this.loading = true;
  //    this.authenticationService.login(null, null, null, this.user.PersonalNumber)
  //      .subscribe(
  //        data => {
  //          this.loading = false;

  //          // login successful so redirect to return url
  //          this.userService.setHttpOptions();

  //          this.loginFinished();

  //        },
  //        error => {
  //          this.loading = false;
  //        });
  //  }
  //  else {
  //    // Starta bankID på samma enhet kräver att sessionen lagras för att läsas upp när man kommer tillbaka till sidan
  //    this.loading = true;
  //    this.authenticationService.loginBankIdPassive(this.user.PersonalNumber, currentUserId)
  //      .subscribe(
  //        data => {
  //          // login successful so redirect to return url
  //          var returnUrl = this.appUrl + "/#/login?bid=" + data;
  //          var bankIdAuthUrl = "https://app.bankid.com/?autostarttoken=" + data + "&redirect=" + returnUrl;
  //          window.location.href = bankIdAuthUrl;
  //        },
  //        error => {
  //          this.loading = false;
  //        });
  //  }
  //}

    openLink(link: string) {
        window.open(link, '_blank');
    }

  redirectToURL(url) {
        window.location.href = url;
    }

  setLoginTab(tab: 'bankid' | 'email') {
    if (tab === 'email' && this.hideEmailForm) {
      return;
    }

    this.selectedLogin = tab;
    if (tab !== 'email') {
      this.clearOtpState();
    }
    this.localStorageService.setItem(this.loginMethodKey, tab);
  }

  onUsernameChange(value: string) {
    this.user.username = value;
    if (value) {
      this.localStorageService.setItem(this.loginEmailKey, value);
    } else {
      this.localStorageService.removeItem(this.loginEmailKey);
    }
  }

  onOtpCodeChange(value: string) {
    this.otpCode = (value || '').replace(/\D/g, '').slice(0, 6);
  }

  onOtpPaste(event: ClipboardEvent) {
    const pastedCode = event.clipboardData?.getData('text') || '';
    const normalizedCode = pastedCode.replace(/\D/g, '').slice(0, 6);
    if (normalizedCode.length !== 6) {
      return;
    }

    event.preventDefault();
    this.otpCode = normalizedCode;

    if (!this.loading) {
      this.verifyOtp();
    }
  }

  focusOtpInput(input: HTMLInputElement) {
    input.focus();
  }

  getOtpSlotValue(index: number) {
    return this.otpCode?.[index] || '';
  }

  isOtpSlotActive(index: number, input: HTMLInputElement) {
    const activeIndex = Math.min((this.otpCode || '').length, 5);
    return document.activeElement === input && index === activeIndex;
  }

  canVerifyOtp() {
    return /^\d{6}$/.test((this.otpCode || '').trim());
  }

  formatCountdown(totalSeconds: number) {
    const safeSeconds = Math.max(0, totalSeconds);
    const minutes = Math.floor(safeSeconds / 60).toString().padStart(2, '0');
    const seconds = (safeSeconds % 60).toString().padStart(2, '0');

    return `${minutes}:${seconds}`;
  }

  private startOtpTimer() {
    this.clearOtpTimer();
    this.updateOtpCountdowns();
    this.otpTimer = setInterval(() => {
      this.ngZone.run(() => this.updateOtpCountdowns());
    }, 1000);
  }

  private updateOtpCountdowns() {
    if (!this.otpChallenge) {
      this.clearOtpTimer();
      return;
    }

    const now = Date.now();
    this.otpExpiresInSeconds = Math.max(0, Math.ceil((this.otpExpiresAtMs - now) / 1000));
    this.otpResendInSeconds = Math.max(0, Math.ceil((this.otpResendAvailableAtMs - now) / 1000));
    this.changeDetectorRef.detectChanges();

    if (this.otpExpiresInSeconds <= 0 && this.otpResendInSeconds <= 0) {
      this.clearOtpTimer();
    }
  }

  private setOtpDeadlines(challenge: PasswordLoginOtpChallenge) {
    const now = Date.now();
    const parsedExpiresAtMs = Date.parse(challenge?.ExpiresAtUtc);
    const parsedResendAtMs = Date.parse(challenge?.ResendAvailableAtUtc);

    this.otpExpiresAtMs = Number.isFinite(parsedExpiresAtMs)
      ? parsedExpiresAtMs
      : now + (10 * 60 * 1000);
    this.otpResendAvailableAtMs = Number.isFinite(parsedResendAtMs)
      ? parsedResendAtMs
      : now + (60 * 1000);
  }

  private clearOtpState() {
    this.otpChallenge = null;
    this.otpCode = '';
    this.otpExpiresInSeconds = 0;
    this.otpResendInSeconds = 0;
    this.otpExpiresAtMs = 0;
    this.otpResendAvailableAtMs = 0;
    this.clearOtpTimer();
  }

  private clearOtpTimer() {
    if (this.otpTimer) {
      clearInterval(this.otpTimer);
      this.otpTimer = null;
    }
  }
}



